<template>
  <main class="container py-2 mx-auto">
    <div class="flex flex-col gap-2">
      <PostCard v-for="post in posts" :horizontal="true" :post="post"/>
    </div>
  </main>
</template>
<script lang="ts" setup>
import {ContentType} from "~/lib/vars";
import PostCard from "~/components/PostCard.vue";

const route = useRoute();
const category = computed(() => route.params.category as ContentType);

const categoryTitle = computed(() => {
  switch (category.value) {
    case ContentType.post:
      return 'Posts';
    case ContentType.kb:
      return 'Knowledgebase Articles';
    default:
      throw new Error('Invalid category');
  }
})

const {data: posts} = await useAsyncData('posts-' + category.value, () => queryContent(category.value)
    .where({"createdAt": {"$exists": true}})
    .without(['body'])
    .sort({updatedAt: -1})
    .find()
);


useHead({
  title: categoryTitle.value,
})

definePageMeta({
  validate({params}) {
    const types: string[] = Object.values(ContentType);
    return types.includes(params.category as string);
  },
})
</script>
